import { Nav, NavDropdown } from "react-bootstrap";
import { User } from "../../models/user";
import * as UserApi from "../../network/user_api";
import { FaUser } from "react-icons/fa6";
import { BiSolidLogOut } from "react-icons/bi";
import { BsFillGearFill } from "react-icons/bs";


interface LoggedUserProps {
    user: User,
    loggedInUser: User | null,
    onLogoutSuccessful: () => void,
}

const LoggedUser = ({ user, onLogoutSuccessful, loggedInUser }: LoggedUserProps) => {
    
    async function logout() {
        try {
            await UserApi.logout();
            onLogoutSuccessful();
        } catch (error) {
            console.error(error);
            alert(error);
        }
    }

    return (
        <Nav data-bs-theme="dark" className="order-4 d-inline-flex d-lg-flex align-items-center">
            <FaUser className="me-1 me-lg-0 d-none d-lg-block" size="12px" color="#888888"/>
            <NavDropdown title={user.name} menuVariant="dark" className="p-lg-0 p-1" align={{ lg: 'end' }}>
                {loggedInUser && (loggedInUser.username === "dp@locs.gr" || loggedInUser.username === "kl@locs.gr")
                &&
                (<>
                <NavDropdown.Item className="small d-flex align-items-center" href="./admin"><BsFillGearFill className="me-1 p-0" />Διαχείριση Χρηστών</NavDropdown.Item>
                <NavDropdown.Divider />
                </>
                )}
                <NavDropdown.Item className="small d-flex align-items-center" onClick={logout}><BiSolidLogOut className="me-1 p-0" />Αποσύνδεση</NavDropdown.Item>
            </NavDropdown>
        </Nav>
    );
};

export default LoggedUser;